module.exports = __webpack_public_path__ + "img/Lokalise-logo.c574dc2.svg";